import React, { useEffect, useState } from 'react';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import Loader from 'src/components/Loader';
import {
  ContactNotesProvider,
  useContactNotesActionsFromContext,
  useContactNotesDataFromContext,
} from 'src/pages/Contact/Context/ContactNotesProvider';

const ContactNotesInner = ({ contact, reFetchContactCountsFromAPI }: any) => {
  const { notes, loadingNotesDocs } = useContactNotesDataFromContext();

  const { fetchNotes, saveNote, updateNote, deleteNote, clearSearch } =
    useContactNotesActionsFromContext();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    clearSearch();
    fetchNotes(contact.id);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [contact.id]);

  const handleSaveNote = async (note: any) => {
    await saveNote(note, contact.id);
    reFetchContactCountsFromAPI();
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, contact.id);
    reFetchContactCountsFromAPI();
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, contact.id);
    reFetchContactCountsFromAPI();
  };

  return loading || loadingNotesDocs ? (
    <Loader />
  ) : (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={`${contact.firstname} ${contact.lastname}`}
      from="contacts"
    />
  );
};

// Main component that provides the context
const ContactNotes = ({
  contact,
  onFetchContactData,
  reFetchContactCountsFromAPI,
}: any) => {
  return (
    <ContactNotesProvider>
      <ContactNotesInner
        contact={contact}
        onFetchContactData={onFetchContactData}
        reFetchContactCountsFromAPI={reFetchContactCountsFromAPI}
      />
    </ContactNotesProvider>
  );
};

export default ContactNotes;
